// extracted by mini-css-extract-plugin
export default {"btn":"FavoriteBtnV2_btn__n2XCn","btn_active":"FavoriteBtnV2_btn_active__L83Id"};